import { TopicCreate } from './TopicCreate';
import { TopicEdit } from './TopicEdit';
import { TopicList } from './TopicList';

export default {
    create: TopicCreate,
    edit: TopicEdit,
    list: TopicList
}
